var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.59668,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3146 20.3829L16.0002 20.1638L15.6858 20.3829L10.7502 23.8218V9.77539C10.7502 9.52686 10.9517 9.32539 11.2002 9.32539H20.8002C21.0487 9.32539 21.2502 9.52686 21.2502 9.77539V23.8218L16.3146 20.3829ZM10.6716 23.8766C10.6716 23.8766 10.6716 23.8766 10.6717 23.8765L10.6716 23.8766Z",
    stroke: "#414141",
    strokeWidth: 1.1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Save.6075d55c56233cffc1dd2179350ec5e2.svg";